import "./style.css";
import styled from "styled-components";
import React, {useEffect, useMemo, useState} from 'react';
import Header from "../Header/Header";
import {getMlistListings} from '../../services/api'; // Import the API call
import TopperSection from "./TopperSection";
import ListingSection from "./ListingSection";




const TheMListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    min-height: 100vh;
`;
export const TheMList = () => {
    const [mlistListings, setMlistListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [listingsPerPage, setListingsPerPage] = useState(25);  // Default listings per page
    const [searchQuery, setSearchQuery] = useState('');  // State for the search query
    const [currentPage, setCurrentPage] = useState(1);  // State for current page
    const [sortConfig, setSortConfig] = useState({key: null, direction: null});

    // Fetch all Mlist listings when the component is mounted
    useEffect(() => {
        const fetchMlistListings = async () => {
            try {
                const data = await getMlistListings();
                console.log(data);
                if (data && Array.isArray(data.mlist_listings)) {
                    // Add a `sortableJoinedAt` field to each listing based on the earliest joined_at date
                    const listingsWithDates = data.mlist_listings.map(listing => ({
                        ...listing,
                        sortableJoinedAt: getEarliestJoinedDate(listing) || null,  // Handle case where listing has no memberships
                    }));
                    setMlistListings(listingsWithDates);
                } else {
                    setMlistListings([]);  // If the response doesn't contain mlist_listings array, set an empty array
                }
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchMlistListings();
    }, []);  // Dependency array to run on component mount

    
    // Helper function to get the earliest joined_at date from group memberships
    const getEarliestJoinedDate = (listing) => {
        if (Array.isArray(listing.group_memberships) && listing.group_memberships.length > 0) {
            // Convert joined_at strings to Date objects and return the earliest
            const dates = listing.group_memberships
                .filter(membership => membership.joined_at)
                .map(membership => new Date(membership.joined_at));
            return dates.length ? new Date(Math.min(...dates)) : null;
        }
        return null;  // Return null if no memberships
    };
    
    
    return (
    <TheMListContainer>
        <TopperSection/>
        <ListingSection/>
    </TheMListContainer>
)

};

export default TheMList;
